import { render, staticRenderFns } from "./ModalResponse.vue?vue&type=template&id=efe31714"
import script from "./ModalResponse.vue?vue&type=script&lang=js"
export * from "./ModalResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports